import TraitLevelFilter from './TraitLevelFilter'
export default TraitLevelFilter
